import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ItemActions from "components/common/ItemActions";
import { nameCapitalize } from "utils/coreUtils";
import { UserFormTypes } from "constants/index";
import styles from "./UserListGrid.module.scss";

export const UserCard = ({
  profileSrc,
  firstName,
  lastName,
  userId,
  isActive,
  loggedInUserId,
  userRoleType,
  marqueeText,
  handleDeleteUser,
  toggleActiveStatusHandler,
  setInfoModal,
  viewUserParam,
}) => {
  const [t] = useTranslation();

  const userEditPath = useMemo(() => {
    let path = `company-user/update-user/${userId}?t=${UserFormTypes.UPDATE_ADMIN_USER}`;
    if (userRoleType === "CU" || userRoleType === "RU") {
      path = `company-user/update-user/${userId}?t=${UserFormTypes.UPDATE_USER}`;
    } else if (userRoleType === "CA") {
      if (userId === loggedInUserId) {
        path = `company-user/update-user?t=${UserFormTypes.UPDATE_ADMIN}`;
      }
    }
    if (userRoleType === UserFormTypes.ROUTING_USER) {
      path = `company-user/update-user/${userId}?t=${UserFormTypes.UPDATE_ROUTING_USER}`;
    }
    return path;
  }, [userId, userRoleType]);

  const renderCheckBox = () => (
    <>
      <input
        className="form-check-input"
        type="checkbox"
        onChange={() => {
          if (Number(userId) === Number(loggedInUserId)) {
            setInfoModal(t("userList.canNotInactive"));
            return false;
          }
          toggleActiveStatusHandler(userId, !isActive);
        }}
        value=""
        id={"user-active-" + userId}
        checked={isActive}
      />
      <label className="form-check-label" htmlFor={"user-active-" + userId}>
        {t("CommonKeys.isActiveLabel")}
      </label>
    </>
  );
  return (
    <div className={`${styles["user-card"]}`}>
      <div className={`${styles["card-content"]}`}>
        {profileSrc ? (
          <img
            width="80"
            height="80"
            alt=""
            className="rounded-circle p-1 border bg-white"
            src={profileSrc}
          />
        ) : (
          <></>
        )}
        <div>
          <h5 className="mb-1">
            {nameCapitalize(firstName)} {nameCapitalize(lastName)}
          </h5>

          <div className="d-flex align-items-baseline flex-column flex-md-row justify-content-between">
            <div className=" d-flex">
              <div className="form-check">{renderCheckBox()}</div>
            </div>
            <div className="user-card-icons mt-1">
              <ItemActions
                classes="m-0"
                size="md"
                editPath={userEditPath}
                viewPath={`company-user/update-user/${userId}?t=${viewUserParam}`}
                validateDelete={() => {
                  if (Number(userId) === Number(loggedInUserId)) {
                    setInfoModal(t("userList.canNotDeleteOwn"));
                    return false;
                  }
                  return true;
                }}
                deleteId={userId}
                deleteHandler={handleDeleteUser}
                deleteMessage={
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t("userList.deleteCompanyUser", {
                        userName: firstName + " " + lastName,
                      }),
                    }}
                  ></span>
                }
              />
            </div>
          </div>

          <marquee>{marqueeText}</marquee>
        </div>
      </div>
    </div>
  );
};
